import { render, staticRenderFns } from "./ecImageContainer.vue?vue&type=template&id=014d7236&scoped=true&lang=pug"
import script from "./ecImageContainer.vue?vue&type=script&lang=ts"
export * from "./ecImageContainer.vue?vue&type=script&lang=ts"
import style0 from "./ecImageContainer.vue?vue&type=style&index=0&id=014d7236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "014d7236",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VCarouselItem: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VCarousel/VCarouselItem.js').default,VCarousel: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VCarousel/VCarousel.js').default})
